export const moduleName = 'healthSystemsList'
